import { LogErrors } from './../../LogErrors'

import { GetCenterSettings as DLGetCenterSettings, SetCenterSettings as DLSetCenterSettings } from './../../DL/Instructor/Settings'


const GetCenterSettings = async () => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: 'No se encontró lo necesario para obtener las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        if (!userData) {
            return { success: false, message: 'No se encontró lo necesario para obtener las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const token = userData?.token
        if (!token) {
            return { success: false, message: 'No se encontró lo necesario para obtener las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const center = userData?.navigation?.center?.id
        if (!center) {
            return { success: false, message: 'No se encontró lo necesario para obtener las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const response = await DLGetCenterSettings(center, token)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetCenterSettings BL', error)
        return { success: false, message: 'No ha sido posible obtener las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const SetCenterSettings = async (settings) => {
    try {
        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: 'No se encontró lo necesario para actualizar las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }
    
        //Obtener la info del usuario desde el session storage
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        if (!userData) {
            return { success: false, message: 'No se encontró lo necesario para actualizar las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const token = userData?.token
        if (!token) {
            return { success: false, message: 'No se encontró lo necesario para actualizar las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const center = userData?.navigation?.center?.id
        if (!center) {
            return { success: false, message: 'No se encontró lo necesario para actualizar las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const theory = settings?.isTheoryVisible
        if (theory === undefined || theory === null) {
            return { success: false, message: 'No se encontró lo necesario para actualizar las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const quizz = settings?.isQuizzVisible
        if (quizz === undefined || quizz === null) {
            return { success: false, message: 'No se encontró lo necesario para actualizar las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const video = settings?.isVideoVisible
        if (video === undefined || video === null) {
            return { success: false, message: 'No se encontró lo necesario para actualizar las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const challenge = settings?.isChallengeVisible
        if (challenge === undefined || challenge === null) {
            return { success: false, message: 'No se encontró lo necesario para actualizar las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const activity = settings?.isActivityVisible
        if (activity === undefined || activity === null) {
            return { success: false, message: 'No se encontró lo necesario para actualizar las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const evaluation = settings?.isEvaluationVisible
        if (evaluation === undefined || evaluation === null) {
            return { success: false, message: 'No se encontró lo necesario para actualizar las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        const response = await DLSetCenterSettings(center, theory, quizz, video, challenge, activity, evaluation, token)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('SetCenterSettings BL', error)
        return { success: false, message: 'No ha sido posible actualizar las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

export { GetCenterSettings, SetCenterSettings };